'use client'
import { excludedPages } from '@/components/ui/sidebar'
import { NAVBAR_HEIGHT_PX } from '@/lib/constans'
import { cn } from '@/lib/utils'
import { useSidebar } from '@/src/store/sidebar-store'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

export default function SidebarWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const { isSideBarOpen } = useSidebar()
  const pathname = usePathname()

  const isHomePage = pathname === '/home'
  const isExcludedPage = useMemo(
    () => excludedPages.includes(pathname ?? ''),
    [pathname]
  )
  const showExpandedSidebar = isSideBarOpen && !isExcludedPage

  return (
    <>
      {isHomePage && <div className="homeBackground" />}
      <main
        className={cn(
          'ease ml-auto flex w-full flex-1 transition-all duration-500 ease-in-out',
          showExpandedSidebar
            ? 'xxl:max-w-[calc(100%_-_var(--sidebar-width))]'
            : 'xxl:max-w-[calc(100%)]'
        )}
        style={{
          marginTop: `calc(${NAVBAR_HEIGHT_PX} + var(--app-banner-height, 0px))`,
        }}
      >
        {children}
      </main>
    </>
  )
}
